<template>
	<div class="availability-dot" :class="{red: type === 1, yellow: type === 2}"></div>
</template>

<script>
export default {
	name: "AvailabilityDot",
	props: {
		type: {type: Number, default: 1, validator(value) {
			return [1, 2].includes(value);
		}},
	},
}
</script>

<style lang="scss" scoped>
.availability-dot {
	width: 11px;
	height: 11px;
	border-radius: 11px;
	border: 2px solid var(--color-bg);
	box-shadow: 0 0 2px var(--color-alpha-3);

	&.red {
		animation: availableColorUnavailable 1.5s linear 0s infinite alternate;
	}

	&.yellow {
		animation: availableColorTimetables 1.5s linear 0s infinite alternate;
	}
}

@keyframes availableColorUnavailable {
	0% {
		background-color: #FC2291;
	}
	100% {
		background-color: #b00e62;
	}
}

@keyframes availableColorTimetables {
	0% {
		background-color: #FDDE00;
	}
	100% {
		background-color: #a28e09;
	}
}
</style>